<template>
  <div v-if="profiles" class="asset-profile">
    <content-nav-bar class="asset-info">
      <svgicon class="level-item" name="profile" width="30" height="30"></svgicon>
      <p v-if="asset.profile" class="level-item">
        Current Profile for Asset: {{ asset.profile.name }}
      </p>
      <p v-else class="level-item">Current Profile for Asset: None</p>
    </content-nav-bar>
    <content-nav-bar>
      <p class="level-item">Select a New Profile:</p>
      <div class="level-item">
        <multiselect
          v-model="selectedProfile"
          :options="profiles.items"
          :searchable="false"
          :close-on-select="true"
          :hide-selected="true"
          selectLabel=""
          placeholder="Select A Profile"
          label="name"
          track-by="name">
        </multiselect>
      </div>
      <a @click="submit" class="level-item button add">
        <i class="fas fa-save"></i>
        Apply Profile To Asset
      </a>
      <loader class="level-item" :showLoader="showLoader">Setting Asset Profile</loader>
    </content-nav-bar>
    <profile-details v-if="selectedProfile" :profile="selectedProfile"></profile-details>
  </div>
</template>

<script>
import ContentNavBar from '@/components/ContentNavBar.vue';
import Multiselect from 'vue-multiselect';
import Loader from '@/components/Loader.vue';
import ProfileDetails from '@/views/profiles/tabs/ProfileDetails.vue';

export default {
  name: 'AssetProfile',
  components: {
    ContentNavBar,
    Multiselect,
    Loader,
    ProfileDetails,
  },
  props: {
    asset: {
      type: Object,
      required: true,
    },
  },
  computed: {
    payload() {
      return {
        uuid: this.asset.uuid,
        profile: `${this.selectedProfile.id}`,
      };
    },
  },
  async mounted() {
    this.profiles = await this.$store.dispatch('primary/listProfiles', {
      direction: 'DESC',
      field: 'created',
    });
    if (this.asset.profile) {
      this.selectedProfile = await this.$store.dispatch('primary/getProfile', { id: this.asset.profile.id });
    }
  },
  methods: {
    async submit() {
      if (this.selectedProfile) {
        this.showLoader = true;
        await this.$store.dispatch('primary/setAssetProfile', this.payload);
        this.showLoader = false;
        await this.$store.dispatch('primary/getAsset', {
          uuid: this.asset.uuid,
        });
      }
    },
  },
  data() {
    return {
      profiles: null,
      showLoader: false,
      message: '',
      selectedProfile: null,
    };
  },
};
</script>

<style lang="scss">
@import '@/scss/colors.scss';

.asset-profile {
  flex: 1;
  display: flex;
  flex-direction: column;

  .asset-info {
    background: $form-subitem;
  }
}

.currrent-profile {
  background: $attention;
}
</style>
